<template>
  <div @click="handleClick" class="clock-icon">
    <img src="../../../../assets/images/icon_dkjl.png" alt="" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import openApp from '../../../../utils/openApp'

export default {
  name: 'ClockIcon',
  computed: {
    ...mapGetters(['systemInfo']),
    ...mapGetters('activityInfo', ['activityId']),
    ...mapGetters('userInfo', ['userInfo']),
  },
  methods: {
    async handleClick() {
      if (this.systemInfo.isWx || this.systemInfo.isNfPlus) {
        if (!this.userInfo.userUuid) {
          await this.$store.dispatch('userInfo/getUserInfo')
        }
        if (!this.userInfo.userUuid && this.systemInfo.isNfPlus) {
          await this.$store.dispatch('userInfo/getNfplusUserByLogin')
        }
        this.$router.push({
          path: '/clockIn/achievement',
          query: { id: this.activityId },
        })
      } else {
        openApp(
          {
            address:
              window.location.origin +
              window.location.pathname +
              this.$router.resolve({
                path: '/',
                query: { id: this.activityId },
              }).href,
          },
          this.activityId,
          40
        )
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.clock-icon {
  width: 1.06rem;
  height: 1.06rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    width: 1.06rem;
    display: inline-block;
  }
  span {
    font-size: 0.24rem;
    color: #333;
  }
}
</style>
